const en = {
  // header
  return_7days: "Return in 7 Days",
  about_us: "About Us",
  cart: "Cart",

  // language toggle
  language: "Language",
  english: "English",
  gujarati: "ગુજરાતી",

  // hero
  hero_eyebrow: "For Indian kitchens",
  hero_title: "Can't start your fan during cooking?",
  hero_sub_1:
    "Kitchen fan that does not blow flame.",
  hero_sub_2: "The best investment for your Mother, Wife or Sister.",
  hero_sub_3: "No more hours of sweat, exhaustion and tiring cooking.",
  read_reviews_44: "Read reviews · 4.3 ★",

  // product
  meet_product: "Meet the product",
  product_name: "Kitchen Platform Fan",
  add_to_cart: "Buy Now — Cash on Delivery",
  buy_now: "Buy Now",
  ask_whatsapp: "Order on WhatsApp",
  in_stock: "In Stock",
  free_shipping: "Free shipping",
  inclusive_of_tax: "incl. of taxes",
  off: "OFF",
  mrp: "MRP",
  rating_n_reviews: "{rating} · {count} reviews",

  // real reviews / videos
  see_action: "See it in action",
  video_section_title: "Real kitchens. Real airflow. Real smiles.",
  unboxing: "Unboxing",
  quick_test: "Quick test",
  customer_use: "Customer use",
  main_demo: "Main demo video coming soon",

  // comparisons
  why_diff_eyebrow: "Why this is different",
  why_diff_title: "Our fan vs Other options",
  others: "Others",
  ours: "Kitchen Cool Fan",
  swipe_for_more: "Swipe →",

  // features summary
  features_eyebrow: "Quick summary",
  features_title: "Everything you need. Nothing extra.",

  // testimonials
  reviews_eyebrow: "Real reviews",
  reviews_title: "Real moms. Real kitchens. Real relief.",

  // trust badges
  trust_eyebrow: "Promises we keep",

  // final cta
  cta_title_1: "",
  cta_title_2: "Every mother deserves relief.",
  cta_lead: "One click. One change. A lifetime of cooler cooking.",
  buy_at: "Buy at ₹{price}",
  chat_first: "Chat on WhatsApp first",

  // sticky bar
  sticky_buy_now: "Buy Now",

  // footer
  footer_about: "About Us",
  footer_contact: "Contact",
  footer_track: "Track Order",
  footer_privacy: "Privacy Policy",
  footer_refund: "Refund Policy",
  footer_whatsapp: "WhatsApp Q&A",
  footer_terms: "Terms",
  copyright: "© 2025 Gruham. All rights reserved.",
  with_care: "Made with care, by mothers for mothers.",

  // checkout
  checkout_title: "Almost there. Just your details.",
  checkout_sub: "Cash on Delivery — pay only when your order arrives.",
  contact_details: "Contact details",
  full_name: "Full name",
  mobile_number: "Mobile number",
  email_optional: "Email (optional)",
  shipping_address: "Shipping address",
  address_line_1: "Address line 1",
  address_line_2: "Address line 2 (optional)",
  city: "City",
  state: "State",
  pincode: "Pincode",
  landmark_optional: "Landmark (optional)",
  order_notes_optional: "Order notes (optional)",
  payment_method: "Payment method",
  cod_label: "Cash on Delivery",
  cod_sub: "Pay only when your order arrives at your doorstep.",
  selected: "Selected",
  order_summary: "Order summary",
  subtotal: "Subtotal",
  shipping: "Shipping",
  free: "FREE",
  total: "Total",
  agree_to: "I agree to the",
  terms_link: "Terms",
  and: "and",
  privacy_link: "Privacy Policy",
  place_order: "Place Order — Cash on Delivery",
  placing: "Placing…",

  // confirmation
  order_placed: "Order placed successfully!",
  order_thanks:
    "Thank you, {name}. We'll call you shortly to confirm your Cash on Delivery order.",
  order_number_label: "Order number",
  track_this_order: "Track this order",
  back_to_home: "Back to Home",

  // track
  track_eyebrow: "Order tracking",
  track_title: "Track your order.",
  track_lead: "Enter your order number or registered mobile number.",
  track_placeholder: "e.g. MC25060312345 or 9876543210",
  track_button: "Track Order",
  placed: "Order placed",
  processing: "Processing",
  shipped: "Shipped",
  delivered: "Delivered",
};

const gu = {
  return_7days: "7 દિવસમાં પરત",
  about_us: "અમારા વિશે",
  cart: "કાર્ટ",

  language: "ભાષા",
  english: "English",
  gujarati: "ગુજરાતી",

  hero_eyebrow: "ભારતીય રસોડા માટે",
  hero_title: "શું રસોઈ કરતી વખતે ફેન ચલાવી શકતા નથી?",
  hero_sub_1:
    "એવો કિચન ફેન જે જ્યોતને ઉડાડતો નથી.",
  hero_sub_2: "તમારી માતા, પત્ની અથવા બહેન માટે શ્રેષ્ઠ રોકાણ.",
  hero_sub_3: "હવે નહીં પરસેવો, થાક કે થકવી નાખતી રસોઈ.",
  read_reviews_44: "રિવ્યુ વાંચો · 4.3 ★",

  meet_product: "પ્રોડક્ટ સાથે પરિચય",
  product_name: "કિચન પ્લેટફોર્મ ફેન",
  add_to_cart: "હવે ખરીદો — કેશ ઓન ડિલિવરી",
  buy_now: "હવે ખરીદો",
  ask_whatsapp: "WhatsApp પર ઓર્ડર કરો",
  in_stock: "સ્ટોકમાં",
  free_shipping: "ફ્રી ડિલિવરી",
  inclusive_of_tax: "ટેક્સ સહિત",
  off: "ડિસ્કાઉન્ટ",
  mrp: "MRP",
  rating_n_reviews: "{rating} · {count} રિવ્યુ",

  see_action: "ચાલતું જુઓ",
  video_section_title: "અસલી રસોડા. અસલી ઠંડક. અસલી હાસ્ય.",
  unboxing: "અનબોક્સિંગ",
  quick_test: "ઝડપી ટેસ્ટ",
  customer_use: "ગ્રાહકોનો ઉપયોગ",
  main_demo: "મુખ્ય ડેમો વિડિયો જલ્દી આવી રહ્યો છે",

  why_diff_eyebrow: "આ કેમ અલગ છે",
  why_diff_title: "Cool Fan vs. અન્ય વિકલ્પો",
  why_diff_lead: "અમે ફેન બદલ્યું નથી. એ બધું બદલ્યું છે જે તેને સહન કરવું પડતું હતું.",
  others: "બીજા",
  ours: "કિચન કૂલ ફેન",
  swipe_for_more: "સ્વાઇપ કરો →",

  features_eyebrow: "ઝડપી સારાંશ",
  features_title: "જરૂરી બધું. વધારાનું કંઈ નહીં.",

  reviews_eyebrow: "અસલી રિવ્યુ",
  reviews_title: "અસલી માતાઓ. અસલી રસોડા. અસલી રાહત.",

  trust_eyebrow: "અમારા વચન",

  cta_title_1: "",
  cta_title_2: "દરેક માતા રાહત માટે લાયક છે.",
  cta_lead: "એક ક્લિક. એક ફેરફાર. જીવનભરની ઠંડી રસોઈ.",
  buy_at: "₹{price}માં ખરીદો",
  chat_first: "પહેલા WhatsApp પર વાત કરો",

  sticky_buy_now: "હવે ખરીદો",

  footer_about: "અમારા વિશે",
  footer_contact: "સંપર્ક",
  footer_track: "ઓર્ડર ટ્રેક કરો",
  footer_privacy: "પ્રાઇવસી પોલિસી",
  footer_refund: "રિફંડ પોલિસી",
  footer_whatsapp: "WhatsApp Q&A",
  footer_terms: "નિયમો",
  copyright: "© 2025 Gruham. બધા હક્કો સુરક્ષિત.",
  with_care: "માતાઓ માટે, માતાઓ દ્વારા, કાળજીપૂર્વક બનાવ્યું.",

  checkout_title: "લગભગ થઈ ગયું. ફક્ત તમારી વિગતો.",
  checkout_sub: "કેશ ઓન ડિલિવરી — ઓર્ડર મળે ત્યારે જ ચૂકવો.",
  contact_details: "સંપર્ક વિગતો",
  full_name: "પૂરું નામ",
  mobile_number: "મોબાઇલ નંબર",
  email_optional: "ઈમેલ (વૈકલ્પિક)",
  shipping_address: "ડિલિવરી સરનામું",
  address_line_1: "સરનામું લાઇન 1",
  address_line_2: "સરનામું લાઇન 2 (વૈકલ્પિક)",
  city: "શહેર",
  state: "રાજ્ય",
  pincode: "પિનકોડ",
  landmark_optional: "લેન્ડમાર્ક (વૈકલ્પિક)",
  order_notes_optional: "ઓર્ડર નોંધ (વૈકલ્પિક)",
  payment_method: "ચૂકવણીની રીત",
  cod_label: "કેશ ઓન ડિલિવરી",
  cod_sub: "ઓર્ડર ઘરે પહોંચે ત્યારે જ ચૂકવો.",
  selected: "પસંદ કરેલ",
  order_summary: "ઓર્ડર સારાંશ",
  subtotal: "પેટા-કુલ",
  shipping: "ડિલિવરી",
  free: "મફત",
  total: "કુલ",
  agree_to: "હું સંમત છું",
  terms_link: "નિયમો",
  and: "અને",
  privacy_link: "પ્રાઇવસી પોલિસી",
  place_order: "ઓર્ડર મૂકો — કેશ ઓન ડિલિવરી",
  placing: "મૂકાઈ રહ્યું છે…",

  order_placed: "ઓર્ડર સફળતાપૂર્વક મુકાયો!",
  order_thanks:
    "આભાર, {name}. અમે તમારા COD ઓર્ડરની પુષ્ટિ માટે ટૂંક સમયમાં ફોન કરીશું.",
  order_number_label: "ઓર્ડર નંબર",
  track_this_order: "આ ઓર્ડર ટ્રેક કરો",
  back_to_home: "હોમ પર પાછા",

  track_eyebrow: "ઓર્ડર ટ્રેકિંગ",
  track_title: "તમારો ઓર્ડર ટ્રેક કરો.",
  track_lead: "તમારો ઓર્ડર નંબર અથવા મોબાઇલ નંબર નાખો.",
  track_placeholder: "દા.ત. MC25060312345 અથવા 9876543210",
  track_button: "ઓર્ડર ટ્રેક કરો",
  placed: "ઓર્ડર મૂક્યો",
  processing: "પ્રક્રિયા હેઠળ",
  shipped: "મોકલ્યું",
  delivered: "પહોંચાડ્યું",
};

export const dictionaries = { en, gu };

export const t = (lang, key, vars = {}) => {
  const dict = dictionaries[lang] || dictionaries.en;
  let str = dict[key] || dictionaries.en[key] || key;
  Object.keys(vars).forEach((k) => {
    str = str.replace(`{${k}}`, vars[k]);
  });
  return str;
};
